<div class="sectionHeader" (click)="filterObject.toggleFilter(id, $event)">
  <div class="spacer"><ng-content></ng-content></div>
  <div>
    <fa-icon [icon]="faChevronDown" *ngIf="!filterObject.section[id]"></fa-icon>
    <fa-icon [icon]="faChevronUp" *ngIf="filterObject.section[id]"></fa-icon>
  </div>
</div>
<div class="sectionBody" *ngIf="filterObject.section[id]">
  <div mat-menu-item (click)="_select()" style="cursor:pointer; display: flex; align-items: center; padding:10px;">
    <ng-container *ngIf="filter.filter.v">
      <div class="spacer app-chip">
        {{ filter.filter.v?.name }}
      </div>
      <div style="margin-left: 10px">
        <fa-icon [icon]="faTimes" (click)="clear($event)"></fa-icon>
      </div>
    </ng-container>
    <ng-container *ngIf="!filter.filter.v">
      <div class="flex-auto app-chip">

        {{ title }}
      </div>
    </ng-container>
  </div>

  <div class="bottom">
    <div class="button" (click)="filter.filter.clear(); refresh()">
      {{ _common.clear }}
    </div>
  </div>
</div>